import { BaseModel } from "sjs-base-model";

export default class ResponseAuthTokensModel extends BaseModel {
    public readonly accessToken: string = "";
    public readonly refreshToken: string = "";

    constructor(data: Partial<ResponseAuthTokensModel>) {
        super();

        this.update(data);
    }
}
